class ObjectRenderer {
  constructor(object, encodings, options) {
    this.object = object;
    this.encodings = encodings;
    this.options = options;
  }
  render() {
    this.object.encodings = this.encodings;
  }
}
var stdin_default = ObjectRenderer;
export {
  stdin_default as default
};
